import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_NEXT_STEPS = gql`
  mutation CreateOrUpdateNextSteps($patientId: ID!, $nextStepId: ID, $nextStepData: NextStepInput!) {
    createOrUpdateNextSteps(patientId: $patientId, nextStepId: $nextStepId, nextStepData: $nextStepData) {
      success
      nextStep {
        id
        patientId
        nextStep
        nextAppointmentType
        nextAppointmentMethod
        timingValue
        timingUnit
        comments
        status
        submittedAt
        practitionerId
        createdAt
        updatedAt
      }
      message
    }
  }
`;

export const SUBMIT_NEXT_STEPS = gql`
  mutation SubmitNextSteps($nextStepId: ID, $patientId: ID, $nextStepData: NextStepInput) {
    submitNextSteps(nextStepId: $nextStepId, patientId: $patientId, nextStepData: $nextStepData) {
      success
      message
    }
  }
`;
